export const FETCH_ALL_PATIENT = 'fetch_all_patient';
export const FETCH_ALL_PATIENT_SUCCESS = 'fetch_all_patient_success';
export const EDIT_PATIENT = 'edit_patient';
export const DELETE_PATIENT = 'delete_patient';
export const CREATE_PATIENT = 'create_patient';
export const CREATE_PATIENT_SUCCESS = 'create_patient_success';
export const UPDATE_PATIENT_SUCCESS = 'update_patient_success';
export const UPDATE_PATIENT = 'update_patient';
export const DELETE_PATIENT_SUCCESS = 'delete_patient_success';
export const SET_PATIENT = 'set_patient';
export const SET_ROLE = 'set_role';